// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Heading__Jsx3 = require("../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function PropertyWizard__WarningHeader$Wrapper(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: TailwindMerge.twMerge([
                    "p-2 border border-solid",
                    className
                  ])
            });
}

var Wrapper = {
  make: PropertyWizard__WarningHeader$Wrapper
};

function PropertyWizard__WarningHeader(props) {
  var __variant = props.variant;
  var variant = __variant !== undefined ? __variant : "Warning";
  var tmp;
  tmp = variant === "Warning" ? "border-tan-warning" : "border-tan-error-500";
  return JsxRuntime.jsx(PropertyWizard__WarningHeader$Wrapper, {
              className: tmp,
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              props.icon,
                              JsxRuntime.jsx(Heading__Jsx3.make, {
                                    as_: "h5",
                                    children: props.headingText
                                  })
                            ],
                            className: "flex flex-row items-center gap-2"
                          }),
                      JsxRuntime.jsx("div", {
                            children: props.children,
                            className: "p-1"
                          })
                    ],
                    className: "flex flex-col items-stretch gap-2 p-1 leading-normal"
                  })
            });
}

var make = PropertyWizard__WarningHeader;

exports.Wrapper = Wrapper;
exports.make = make;
/* Heading__Jsx3 Not a pure module */
